import { Box, Grid, Paper } from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

import TextInfo from "../../../components/textInfo";
import RFPStatusTooltipTitle from "../../../components/rfpStatusTooltipTitle";
import { RFPDetailsState } from "../types";
import { RFP_STATUSES, isValidRFPStatus } from "../../../constants/rfp";

type Props = {
  state: RFPDetailsState;
};

const RfpStatus = ({ state }: Props): JSX.Element => {
  const dates = state?.data?.rfpStatusHistory?.map(
    (date) => new Date(date.lastUpdateDate),
  );
  const maxDate = dates?.length
    ? dates.reduce((a, b) => (a > b ? a : b))
    : undefined;
  const statusKey = state?.data?.rfp?.details?.status ?? null;
  const status = isValidRFPStatus(statusKey) ? RFP_STATUSES[statusKey] : "";

  return (
    <Paper sx={{ p: 4 }}>
      <Box>
        <TextInfo tootltipMsg={<RFPStatusTooltipTitle />} mb={3}>
          <Typography variant="header-large">RFP Status</Typography>
        </TextInfo>
        <Grid container spacing={3}>
          <Grid display="flex" alignItems="center">
            <Box
              bgcolor={({ palette }) => palette.brandPrimary.main}
              width="1rem"
              height="1rem"
              borderRadius="50%"
              mr={1}
            />
            <Typography variant="body-large">
              <strong>{status}</strong>
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body-medium">
              {maxDate !== undefined ? customDate(maxDate) : "Not available"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

const specialDates = { 1: "st", 2: "nd", 3: "rd" };

const options = {
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "numeric",
  hour12: true,
} as const;

const customDate = (date: string | number | Date) => {
  const legacyDate = new Date(date);
  const modifiedDate = legacyDate.toLocaleString("en-US", options);
  const newDate = modifiedDate.replace(
    " at",
    `${specialDates[legacyDate.getDate()] ?? "th"},`,
  );
  return newDate;
};

export default RfpStatus;
